import {FeatureModel} from "./integration/representation/viewmodel";
import {noLocationals} from "./locationalUtilities";
import {Locational} from "./integration/representation/feature";


export class MeteringDirectionMissingError extends Error {
    constructor(message: string) {
        super(message);
        this.name = "MeteringDirectionMissingError";
    }
}

export function allLocationalsHaveMeteringDirection(feature: FeatureModel): boolean {
    if (noLocationals(feature)) {
        return true;
    }
    return feature.locational.locationals
        .filter(locational => !locationalHasMeteringDirection(locational))
        .length === 0;
}

export function locationalHasMeteringDirection(locational: Locational): boolean {
    return locational.meteringDirection != null;
}
